import { useTransition } from 'react';
import { MutationFunction, useMutation, UseMutationOptions } from 'react-query';
import { useDigitalContext } from '../../context/digital';

export const useCustomMutation = <
  TData = any,
  TError = unknown,
  TVariables = void,
  TContext = unknown,
>(
  mutationFn: MutationFunction<TData, TVariables>,
  options: UseMutationOptions<TData, TError, TVariables, TContext> = {} as UseMutationOptions<
    TData,
    TError,
    TVariables,
    TContext
  >
) => {
  const { dispatch } = useDigitalContext();
  const [, startTransition] = useTransition();

  return useMutation({
    mutationFn,
    ...options,
    onSuccess: (data: TData) => {
      (options.onSuccess as ((data?: TData) => void) | undefined)?.(data);
    },
    onError: (error: any) => {
      if (error.response.data.error_id === 'non_working_time') {
        startTransition(() => {
          dispatch({ type: 'NON_WORKING_HOUR', payload: true });
        });

        return;
      }
      (options.onError as ((error?: TError) => void) | undefined)?.(error);
    },
    useErrorBoundary: options.useErrorBoundary ?? true,
  });
};
